<template>
  <router-view />
</template>

<script>
export default {
  components: {},
  data: function () {
    return {
      loaded: false,
    };
  },
  mounted() {
    document.body.classList.add('auth');
  },
};
</script>
